<template>
  <svg class="pictoArrow" :class="orientation" xmlns="http://www.w3.org/2000/svg" width="39.95" height="20" viewBox="0 0 39.95 20"><g transform="translate(39.95) rotate(90)"><line y1="4.621" x2="4.621" transform="translate(0 23.764)"/><path d="M0,0" transform="translate(0 9.719)"/><path d="M10.256,19.974,0,30.23v9.7l.025.025L20,19.974.025,0,0,.025V9.719Z" transform="translate(0)"/></g></svg>
</template>

<script>

export default {
  name: 'PictoArrow',
  props: {
    orientation: {
      type: String,
      default: 'bas'
    }
  }
}
</script>

<style lang="scss">
  .droite {
    transform: rotate(-90deg) !important;
  }
</style>
